import React from 'react';
import HomeScreenConfigForm from './HomeScreenConfigForm';

const EditHomeScreenConfig = ({ show, onHide, rowData }) => (
  <HomeScreenConfigForm show={show} onHide={onHide} mode="edit" initialRow={rowData || null} />
);

export default EditHomeScreenConfig;
